module.exports = ":host /deep/ router-outlet ~ * {\n  display: block;\n  position: relative; }\n"